export default "__VITE_ASSET__Bk1h_Grp__";